import { createAction } from '@reduxjs/toolkit';
import * as containerConstants from './constants';
import type { Customer } from '@/lib/types';

export const loadCustomers = createAction(containerConstants.LOAD_CUSTOMERS);

export const loadCustomersSuccess = createAction(
  containerConstants.LOAD_CUSTOMERS_SUCCESS,
  (customers: any[]) => ({ payload: { customers } })
);

export const loadCustomersError = createAction(
  containerConstants.LOAD_CUSTOMERS_ERROR,
  (error: string) => ({ payload: { error } })
);

export const saveCustomerRequest = createAction(
  'customers/SAVE_CUSTOMER_REQUEST',
  (customer: Customer, isNew: boolean) => ({ payload: { customer, isNew } })
);

export const deleteCustomerRequest = createAction(
  'customers/DELETE_CUSTOMER_REQUEST',
  (id: string) => ({ payload: { id } })
);

export const collectBalanceRequest = createAction(
  'customers/COLLECT_BALANCE_REQUEST',
  (id: string, amount: number, paymentMethod?: string, note?: string) => ({
    payload: { id, amount, paymentMethod, note },
  })
);
